import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useOnlineStatus } from "~/lib/hooks/use-online-status";
import { cn } from "~/lib/utils/cn";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-white",
      )}
      role="alert"
    >
      <WifiOff className="h-4 w-4" />
      <span>{t("offline.banner")}</span>
    </div>
  );
}
